import { render } from "./HeaderScroll.vue?vue&type=template&id=3622f9fb&scoped=true"
import script from "./HeaderScroll.vue?vue&type=script&lang=js"
export * from "./HeaderScroll.vue?vue&type=script&lang=js"

import "./HeaderScroll.vue?vue&type=style&index=0&id=3622f9fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3622f9fb"]])

export default __exports__